// Reusable Page Hero component for consistent hero images across pages
const PageHero = ({ image, alt, objectPosition = 'center' }) => {
  return (
    <section className="pt-24 md:pt-28">
      <div className="w-full h-[300px] md:h-[400px] overflow-hidden">
        <img 
          src={image}
          alt={alt}
          className="w-full h-full object-cover"
          style={{ objectPosition }}
        />
      </div>
    </section>
  );
};

export default PageHero;
